/*
 * .env.local で定義している環境変数を参照
 *   ex) NEXT_PUBLIC_FIREBASE_API_KEYの値が、「FIREBASE_API_KEY」に保持される
 */
export const FIREBASE_API_KEY = process.env["NEXT_PUBLIC_FIREBASE_API_KEY"] ?? "";
export const FIREBASE_AUTH_DOMAIN = process.env["NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN"] ?? "";
export const FIREBASE_PROJECT_ID = process.env["NEXT_PUBLIC_FIREBASE_PROJECT_ID"] ?? "";
export const FIREBASE_STORAGE_BUCKET = process.env["NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET"] ?? "";
export const FIREBASE_MESSAGING_SENDER_ID =
  process.env["NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID"] ?? "";
export const FIREBASE_APP_ID = process.env["NEXT_PUBLIC_FIREBASE_APP_ID"] ?? "";
export const FIREBASE_MEASUREMENT_ID = process.env["NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID"] ?? "";
